import React, {Component} from 'react';
import cogoToast from 'cogo-toast';
import {gettext} from '../../../translations';
import socketService, {SocketStatus} from '../SocketService';

// Long enough that a brief blip reconnects before we warn about it.
const NOTICE_DELAY = 3000;

const styles = {
    bar: {
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1050,
        padding: '6px 12px',
        textAlign: 'center',
        fontSize: 12,
        color: '#fff',
        backgroundColor: '#c0392b',
    },
    icon: {
        marginRight: 8,
    },
};


class ConnectionStatus extends Component {

    constructor(props) {
        super(props);

        this.state = {visible: false};

        this.noticeTimeout = null;
        this.hasWarned = false;

        this.handleStatusChange = this.handleStatusChange.bind(this);
    }


    componentDidMount() {
        this.unsubscribe = socketService.onStatusChange(this.handleStatusChange);
    }


    componentWillUnmount() {
        if (this.unsubscribe) this.unsubscribe();
        this.clearNoticeTimeout();
    }


    handleStatusChange(status) {
        if (status === SocketStatus.CONNECTED) {
            this.clearNoticeTimeout();

            if (this.hasWarned) {
                this.hasWarned = false;
                cogoToast.success(gettext("Connection restored. Prices are up to date again."), {hideAfter: 4});
            }

            if (this.state.visible) this.setState({visible: false});
            return;
        }

        if (this.noticeTimeout || this.hasWarned) return;

        this.noticeTimeout = setTimeout(() => {
            this.noticeTimeout = null;
            this.hasWarned = true;

            this.setState({visible: true});
            cogoToast.warn(gettext("Connection lost. Prices may be out of date while we reconnect."), {hideAfter: 6});
        }, NOTICE_DELAY);
    }


    clearNoticeTimeout() {
        if (this.noticeTimeout) {
            clearTimeout(this.noticeTimeout);
            this.noticeTimeout = null;
        }
    }


    render() {
        if (!this.state.visible) return null;

        return (
            <div style={styles.bar} role="status">
                <i className="fa fa-exclamation-triangle" style={styles.icon}/>
                {gettext("Connection lost. Trying to reconnect - prices may be out of date.")}
            </div>
        );
    }
}

export default ConnectionStatus;
